<template>
  <a role="button" class="BackButton">
    <span v-html="arrowLeftSvg" class="icon" />
    <div class="text"><slot /></div>
  </a>
</template>

<script setup>
import arrowLeftSvg from '~/assets/site-nav/arrow-left.svg?raw'
</script>

<style scoped>
.BackButton {
  display: flex;
  align-items: center;
  color: var(--brand-color);
}
.text {
  margin-left: var(--spacing-4);
  font-size: var(--font-size-4);
}
</style>
